import { useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import AsyncSelect from "react-select/async";
import debounce from "lodash/debounce";

const MultiSelectAsync = ({
  fetchOptions,
  mapResponse,
  defaultOptions = [],
  onChange,
  placeholder,
}) => {
  const debouncedLoadOptions = useMemo(() => debounce((inputValue, callback) => {
    try {
      fetchOptions(inputValue).then(response => {
        const mappedData = mapResponse(response);

        callback(mappedData);
      });
    } catch (error) {
      console.error('Error fetching options:', error);
      toast.error('Error fetching options');

      callback([]);
    }
  }, 300), [fetchOptions, mapResponse]);

  useEffect(() => {
    return () => debouncedLoadOptions.cancel();
  }, [debouncedLoadOptions]);

  const memoizedDefaultOptions = useMemo(() => defaultOptions, [defaultOptions]);

  const handleChange = value => {
    if (onChange) onChange(value);
  }

  return (
    <AsyncSelect
      isMulti
      cacheOptions
      loadOptions={debouncedLoadOptions}
      onChange={handleChange}
      defaultOptions={memoizedDefaultOptions}
      placeholder={placeholder}
      className="text-xs"
    />
  )
}

export default MultiSelectAsync;